// extracted by mini-css-extract-plugin
module.exports = {"common_section":"commonSection_common_section__cY8Z2"};